export default "__VITE_ASSET__UiLLJNEtUeNZZuI6T$$Qww__"